// extracted by mini-css-extract-plugin
export default {"home":"Home_home__sr6M3","anim":"Home_anim__dKbOv","ct":"Home_ct__ibGNZ","cr":"Home_cr__w5R94"};